:host {
	display: grid;
	gap: 5rem;
	box-sizing: border-box;
	max-width: 80rem;
	width: 100%;
	margin: auto;
	padding: 2rem;
}
